// extracted by css-extract-rspack-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1_sVm","cls2":"AboutTheAuthorsSection-cls2_lFm AboutTheAuthorsSection-cls1_sVm"};